import React from "react";
import GateIn from "./views/GateIn";
import { GateInContextProvider } from "./GateInView";

const GateInPage = () => {
  return (
    <GateInContextProvider>
      <GateIn />
    </GateInContextProvider>
  );
};

export default GateInPage;
